import { first, get } from 'lodash'
import React from 'react'
import { useQuery } from 'react-query'
import hooks from '../../../hooks'

const useIncompleteUserReflections = () => {
    const { isActive, snooze } = hooks.useSnooze({ durationMinutes: 120 })
    const cacheKeys = hooks.useCacheKeys()
    const { api, endpoints, url, time } = hooks.useApi()
    const { id: userId, isStudent } = hooks.useCurrentUser()
    const { endpoints: clientEndpoints, toLocation } = hooks.useClientLocation()

    const { data, isLoading } = useQuery(
        [cacheKeys.USER_REFLECTIONS, userId, 'incomplete'],
        () => api.get(url(endpoints.userReflections, {userId}, { active: true })),
        {
            staleTime: time.HOUR,
            enabled: Boolean(userId)
        }
    )

    const userReflections = get(data, 'items', []).filter(r => !r.content)
    const hasReflections = isStudent && !isLoading && isActive && userReflections.length

    const toReflection = React.useCallback(() => {
        if (userReflections.length) {
            const userReflection = first(userReflections)
            const promptId = get(userReflection, 'id')
            toLocation(url(clientEndpoints.USER_REFLECTION, { userId, promptId }))
        }
        snooze()
    }, [userReflections, userId, toLocation, url, endpoints, snooze])

    return {
        hasReflections,
        toReflection,
        dismiss: snooze
    }
}

export default useIncompleteUserReflections
